import React from 'react';
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Header from "../../components/Header";
import Login from "../../components/Login/Login";
import {parentContainer} from "../../config/theme";

class LoginParent extends React.Component {
  render () {
    return (
      <div style={parentContainer}>
        <Grid container>
          <Header history={this.props.history} />
          <Grid container alignItems={"center"} justify={"center"} alignContent={"center"}>
            <Login history={this.props.history} />
          </Grid>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};

const LoginPage = connect(mapStateToProps)(LoginParent);

export default LoginPage;
